import http from '@/services/http';
import { router } from '@/router';
import { User } from '@/interfaces/user.interface';

export default {
  async login(email: string, password: string) {
    const postData = JSON.stringify({email, password});
    const response = await http.post(
        `/login`,
        postData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
    );
    return response.data;
  },
  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('authToken');
    router.push('/login');

  },
  isLoggedIn() {
    // TODO: Validate JWT token instead of just checking for user presence
    return localStorage.getItem('user')
        && localStorage.getItem('authToken');
  },
  async getAll() {
    const response = await http.get(`/users`);
    return response.data;
  },
  async fetchPermissions() {
    const response = await http.get(`/permissions`);
    return response.data;
  },
  async fetchRoles() {
    const response = await http.get(`/users/roles`);
    return response.data;
  },
  async fetchGroups() {
    const response = await http.get(`/users/groups`);
    return response.data;
  },
  async create(user: User) {
    const response = await http.post(`/users`, user);
    return response.data;
  },
  async update(user: User) {
    const response = await http.put(`/users/${user.uuid}`, user);
    return response.data;
  },
  async delete(uuid: string) {
    const response = await http.delete(`/users/${uuid}`);
    return response.data;
  }
};
